import { useEffect, useRef, useState } from "react";
import { useAuth } from "../../hooks/useAuth";
import { ReactComponent as UserIcon } from "../../icons/User.svg";
import DownArrowIcon from "../icons/DownArrowIcon";
import UpArrowIcon from "../icons/UpArrowIcon";
import UserDropdown from "../userDropDownMenu/UserDropdown";
import "./UserButton.css";

function UserButton({ isExpandable = false }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { claims } = useAuth();

  const toggleDropdown = () => setIsOpen(!isOpen);

  useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="App-user-button-container" ref={dropdownRef}>
      <div
        className={`App-user-button ${isExpandable ? "expandable" : ""}`}
        onClick={toggleDropdown}
      >
        <div className="App-user-button-icon">
          <UserIcon />
        </div>
        <span>{claims.fullName}</span>
        {isExpandable && (
          <div className="App-user-button-arrow-icon">
            {isOpen ? <UpArrowIcon /> : <DownArrowIcon />}
          </div>
        )}
      </div>
      <UserDropdown isOpen={isOpen} />
    </div>
  );
}

export default UserButton;
